import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './BrandFilterList';

const BrandFilterListSuspense = dynamic(() => import('./BrandFilterList'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicBrandFilterList(props: Props) {
	return <BrandFilterListSuspense {...props} />;
}
DynamicBrandFilterList.displayName = 'DynamicBrandFilterList';
